module.exports = __webpack_public_path__ + "static/media/creeper-one.8ed420d5.png";